<template>
    <div class="file-input__wrapper" v-if="shouldShow">
        <div class="file-input__title">
            <span :class="provision ? 'd-block' : 'd-block mb-2'">
                {{ title }}
            </span>
            <template v-if="subTitle">
                <div v-if="typeof subTitle === 'string'">
                    {{ subTitle }}
                </div>
                <span class="d-block" v-else-if="subTitle instanceof Array" v-for="text in subTitle">
                    {{ text }}
                </span>
            </template>
            <div v-if="provision" class="provision" >
                {{ provision }}
            </div>
        </div>
        <div class="position-relative">
            <input v-if="editable" multiple ref="file" type="file" name="files[]" :id="documentType" v-on:change="attachDoc()" :data-document="documentType">
            <div class="attach-block">
                <div v-if="editable" class="attach-buttons">
                    <label :for="documentType" class="file-input__label">
                        <span>
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_263_1917)">
                                    <path d="M5.375 7.37573L8 10L10.625 7.37573" stroke="#007A40" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8 3V9.99816" stroke="#007A40" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13.5 10V13.5C13.5 13.6326 13.4473 13.7598 13.3536 13.8536C13.2598 13.9473 13.1326 14 13 14H3C2.86739 14 2.74021 13.9473 2.64645 13.8536C2.55268 13.7598 2.5 13.6326 2.5 13.5V10" stroke="#007A40" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_263_1917">
                                        <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                        <span>
                            {{
                                {
                                    ru: 'Загрузить документ',
                                    kz: 'Құжатты жүктеп салу',
                                    en: 'Upload document',
                                }[getLang()]
                            }}
                        </span>
                    </label>

                    <button type="button" class="file-input__existing-btn" @click="showExistingDocuments">
                        <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 2.5C2 2.22386 2.22386 2 2.5 2H6.08579C6.21839 2 6.34557 2.05268 6.43934 2.14645L8.5 4.20711V13.5C8.5 13.7761 8.27614 14 8 14H2.5C2.22386 14 2 13.7761 2 13.5V2.5Z" stroke="#007A40" stroke-width="1.2"/>
                                <path d="M8.5 4.5H13.5C13.7761 4.5 14 4.72386 14 5V13.5C14 13.7761 13.7761 14 13.5 14H10" stroke="#007A40" stroke-width="1.2"/>
                                <path d="M6 6H12" stroke="#007A40" stroke-width="1.2"/>
                                <path d="M6 8H12" stroke="#007A40" stroke-width="1.2"/>
                                <path d="M6 10H12" stroke="#007A40" stroke-width="1.2"/>
                            </svg>
                        </span>
                        <span>
                            {{
                                {
                                    ru: 'Выбрать из архива',
                                    kz: 'Мұрағаттан таңдау',
                                    en: 'Choose from archive',
                                }[getLang()]
                            }}
                        </span>
                    </button>
                </div>

                <div class="validation-error" v-if="validationError">{{validationError}}</div>
                <div class="attach_files" v-if="datadocuments">
                    <div class="attach_name" v-for="file in datadocuments" :key="file.id">
                        <input type="hidden" :name="this.documentType" :value="file.file.name">

                        <a class="attach_name__link" target="_blank" :href="file.file.url">{{ file.file.name }}</a>
                        <svg  v-if="editable" @click="deleteFile(file.id)" width="10" height="10" viewBox="0 0 14 14" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.2997 0.710215C12.9097 0.320215 12.2797 0.320215 11.8897 0.710215L6.99973 5.59022L2.10973 0.700215C1.71973 0.310215 1.08973 0.310215 0.699727 0.700215C0.309727 1.09021 0.309727 1.72022 0.699727 2.11022L5.58973 7.00022L0.699727 11.8902C0.309727 12.2802 0.309727 12.9102 0.699727 13.3002C1.08973 13.6902 1.71973 13.6902 2.10973 13.3002L6.99973 8.41021L11.8897 13.3002C12.2797 13.6902 12.9097 13.6902 13.2997 13.3002C13.6897 12.9102 13.6897 12.2802 13.2997 11.8902L8.40973 7.00022L13.2997 2.11022C13.6797 1.73022 13.6797 1.09022 13.2997 0.710215Z"
                                fill="#EC746E"/>
                        </svg>
                    </div>
                </div>
                <div class="attach-error" v-if="error">
                    *{{ error }}
                </div>
                <a v-if="fileTemplatePath" :href="fileTemplatePath" class="form-download" download>
                    <span>
                        {{
                            {
                                ru: 'Скачать шаблон',
                                kz: 'Үлгіні жүктеп алу',
                                en: 'Download template',
                            }[getLang()]
                        }}
                    </span>
                </a>
            </div>
        </div>

        <!-- Модальное окно с существующими документами -->
        <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5)">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{
                                {
                                    ru: 'Выберите документ из архива',
                                    kz: 'Мұрағаттан құжат таңдаңыз',
                                    en: 'Choose document from archive',
                                }[getLang()]
                            }}
                        </h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="loadingDocuments" class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Загрузка...</span>
                            </div>
                        </div>
                        <div v-else-if="existingDocuments.length === 0" class="text-center text-muted">
                            <p>
                                {{
                                    {
                                        ru: 'У вас пока нет загруженных документов',
                                        kz: 'Сізде әлі жүктелген құжаттар жоқ',
                                        en: 'You have no uploaded documents yet',
                                    }[getLang()]
                                }}
                            </p>
                        </div>
                        <div v-else class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>
                                        {{
                                            {
                                                ru: 'Название',
                                                kz: 'Атауы',
                                                en: 'Name',
                                            }[getLang()]
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            {
                                                ru: 'Файл',
                                                kz: 'Файл',
                                                en: 'File',
                                            }[getLang()]
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            {
                                                ru: 'Дата',
                                                kz: 'Күні',
                                                en: 'Date',
                                            }[getLang()]
                                        }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="doc in existingDocuments" :key="doc.id"
                                    :class="{ 'table-success': selectedDocuments.includes(doc.id) }"
                                    style="cursor: pointer" @click="toggleDocumentSelection(doc)">
                                    <td>{{ doc.document_name }}</td>
                                    <td><code>{{ doc.file.name }}</code></td>
                                    <td>{{ formatDate(doc.created_at) }}</td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeModal">
                            {{
                                {
                                    ru: 'Отмена',
                                    kz: 'Болдырмау',
                                    en: 'Cancel',
                                }[getLang()]
                            }}
                        </button>
                        <button type="button" class="btn btn-primary"
                                @click="attachSelectedDocuments"
                                :disabled="selectedDocuments.length === 0">
                            {{
                                {
                                    ru: 'Прикрепить выбранные',
                                    kz: 'Таңдалғандарды тіркеу',
                                    en: 'Attach selected',
                                }[getLang()]
                            }}
                            <span v-if="selectedDocuments.length > 0" class="badge bg-light text-dark ms-1">
                                {{ selectedDocuments.length }}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {setFormValue, getFormValue} from './fields/formStore';

export default {
    name: 'FileInput',
    emits: ['update:modelValue'],
    data() {
        return {
            error: '',
            datadocuments: JSON.parse(JSON.stringify(this.documents)),
            showModal: false,
            existingDocuments: [],
            selectedDocuments: [],
            loadingDocuments: false,
        };
    },
    mounted() {
        setFormValue(this.documentType, this.shouldShow && this.datadocuments.length > 0);
    },
    props: {
        isRequired: {type: Boolean, default: false},
        title: String,
        provision: String,
        subTitle: null,
        id: String,
        documents: Array,
        documentType: String,
        validationError: String,
        fileTemplatePath: String,
        model: String,
        fieldId: String,
        conditionalField: {type: String, default: ''},
        editable: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        shouldShow() {
            const key = this.conditionalField;
            if (!key) return true;
            const v = getFormValue(key);
            return this.isFilledForCondition(v);
        },
    },

    watch: {
        shouldShow(visible) {
            if (!visible) {
                setFormValue(this.documentType, false);
            }
        },
    },

    methods: {
        isFilledForCondition(v) {
            if (v === true || v === 1 || v === '1') return true;
            if (typeof v === 'string') return v.trim().length > 0;
            if (Array.isArray(v)) {
                if (v.length === 0) return false;
                const looksLikeRows = v[0] && typeof v[0] === 'object' && !Array.isArray(v[0]);
                if (looksLikeRows) {
                    const rowHasAnyValue = (row) =>
                        Object.values(row || {}).some((cell) => {
                            if (cell === true || cell === 1 || cell === '1') return true;
                            if (typeof cell === 'number') return true; // 0 допустим
                            if (typeof cell === 'string') return cell.trim().length > 0;
                            if (Array.isArray(cell)) return cell.length > 0;
                            if (cell && typeof cell === 'object') return Object.keys(cell).length > 0;
                            return false;
                        });
                    return v.some(rowHasAnyValue);
                }
                return v.length > 0;
            }
            if (v && typeof v === 'object') return true;
            if (typeof v === 'number') return true;
            return !!v;
        },
        async attachDoc() {
            if (!this.$refs.file.files?.length) return;

            for (const file of this.$refs.file.files) {
                const formData = new FormData();
                formData.append('document', file);
                formData.append('field_id', this.fieldId);
                formData.append('model_id', this.id);
                formData.append('model_type', this.model);

                try {
                    const resp = await axios.post('/api/v1/attachDocument', formData, {
                        headers: {'X-CSRF-TOKEN': this.getToken()},
                    });
                    this.datadocuments.push(resp.data.document);
                    setFormValue(this.documentType, true);
                } catch (e) {
                    const status = e.response?.status;
                    const message = e.response?.data?.message;
                    const lang = this.getLang();

                    const messages = {
                        413: {
                            ru: 'Размер файла превышает допустимый лимит.',
                            kz: 'Файл өлшемі рұқсат етілген шектен асады.',
                            en: 'The file size exceeds the allowed limit.',
                        },
                        default: {
                            ru: 'Ошибка при загрузке файла. Попробуйте снова.',
                            kz: 'Файлды жүктеу кезінде қате пайда болды. Қайталап көріңіз.',
                            en: 'An error occurred while uploading the file. Please try again.',
                        },
                    };

                    if (status === 413) {
                        this.error = messages[413][lang] || messages[413].ru;
                    } else {
                        this.error = message || messages.default[lang] || messages.default.ru;
                    }

                    if (this.$toast) {
                        this.$toast.error(this.error);
                    }

                    break;
                }
            }
            this.$refs.file.value = '';
        },

        async showExistingDocuments() {
            this.showModal = true;
            this.loadingDocuments = true;
            this.selectedDocuments = [];

            try {
                const response = await axios.get('/api/v1/company/documents', {
                    headers: {'X-CSRF-TOKEN': this.getToken()},
                });
                this.existingDocuments = response.data.documents;
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка загрузки документов';
                console.error('Error loading documents:', error);
            } finally {
                this.loadingDocuments = false;
            }
        },

        toggleDocumentSelection(document) {
            const index = this.selectedDocuments.indexOf(document.id);
            if (index > -1) {
                this.selectedDocuments.splice(index, 1);
            } else {
                this.selectedDocuments.push(document.id);
            }
        },

        async attachSelectedDocuments() {
            if (this.selectedDocuments.length === 0) return;

            try {
                const requests = this.selectedDocuments.map(documentId => {
                    const formData = new FormData();
                    formData.append('document_id', documentId);
                    formData.append('field_id', this.fieldId);
                    formData.append('model_id', this.id);
                    formData.append('model_type', this.model);

                    return axios.post('/api/v1/attachExistingDocument', formData, {
                        headers: {'X-CSRF-TOKEN': this.getToken()},
                    });
                });

                const responses = await Promise.all(requests);

                // Добавляем прикрепленные документы к списку
                responses.forEach(response => {
                    this.datadocuments.push(response.data.document);
                });

                setFormValue(this.documentType, this.datadocuments.length > 0);

                this.closeModal();
                this.error = '';
            } catch (error) {
                this.error = error.response?.data?.message || 'Ошибка при прикреплении документов';
                console.error('Error attaching existing documents:', error);
            }
        },

        closeModal() {
            this.showModal = false;
            this.selectedDocuments = [];
        },

        deleteFile(idx) {
            const formData = new FormData();
            formData.append('document_id', idx);
            formData.append('form_field_id', this.fieldId);
            formData.append('application_id', this.id);

            axios.post('/api/v1/detachDocument', formData, {headers: {'X-CSRF-TOKEN': this.getToken()}})
                .then((response) => {
                    this.datadocuments = this.datadocuments.filter(item => item.id !== idx);
                    setFormValue(this.documentType, this.datadocuments.length > 0);
                })
                .catch(error => {
                    alert(error);
                });
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        },

        getLang() {
            return document.querySelector('html').getAttribute('lang') || 'ru';
        },
    },
};
</script>

<style scoped>
.attach-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: nowrap;
    margin-bottom: 15px;
}

.file-input__existing-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: #f8f9fa;
    border: 1px solid #007A40;
    border-radius: 4px;
    color: #007A40;
    text-decoration: none;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.file-input__existing-btn:hover {
    background: #e9ecef;
    transform: translateY(-1px);
}

.modal.show {
    display: block !important;
}

.table-responsive {
    max-height: 400px;
    overflow-y: auto;
}

.table tbody tr:hover {
    background-color: #f8f9fa;
}

.table tbody tr.table-success {
    background-color: #d1eddd;
}
</style>
